import { render, staticRenderFns } from "./companyContactInfo.vue?vue&type=template&id=06492132"
import script from "./companyContactInfo.vue?vue&type=script&lang=js"
export * from "./companyContactInfo.vue?vue&type=script&lang=js"
import style0 from "./companyContactInfo.vue?vue&type=style&index=0&id=06492132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports